export default {
    Message: 1,
    AgentJoined: 11,
    AgentLeft: 12,
    ChatStarted: 21,
    ChatResolved: 22
};
